import { Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { sendPaymentAcknowledgement } from '../../../../helpers/api';
import { openNotification } from '../../../../helpers/notification';

export default function PaymentAcknowledgement({ open, onClose, paymentItem }) {
  const [sending, setSending] = useState(false);

  const handleSendAcknowledgement = async () => {
    setSending(true);
    try {
      const res = await sendPaymentAcknowledgement(paymentItem?.id);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({
          status: 'success',
          message: status?.desc,
        });
        onClose();
      } else {
        openNotification({
          status: 'error',
          message: status?.desc,
        });
      }
    } catch (error) {
      openNotification({
        status: 'error',
        message: 'Something went wrong. Please try again',
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          Acknowledge Payment
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent sx={{}}>
        <Alert icon={false} severity="info">
          <Typography>
            Acknowledging the payment of{' '}
            {Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(
              paymentItem?.amountPaid
            )}
          </Typography>
        </Alert>
        <br />
        <Typography variant="body2">{`If you proceed, an email will be sent to the facility personels, notifying them that their payment has been acknowledged`}</Typography>
        <br />
        <Typography variant="body2" color="error">{`Are you sure you want to proceed?`}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          type="button"
          variant="contained"
          size="medium"
          sx={{ textTransform: 'none', borderRadius: '30px' }}
          onClick={handleSendAcknowledgement}
          disabled={sending}
          startIcon={sending && <CircularProgress size={20} />}
        >
          Yes, Send Acknowledgement
        </Button>
      </DialogActions>
    </Dialog>
  );
}
